module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat2_cn@3x.88ac950b.png";